export default __webpack_public_path__ + "static/media/flag-kuwait.95414f18.svg";